import React from 'react';

import FolderFormModal from './FolderFormModal';
import { CreateFolderModalProps } from './types';

const CreateFolderModal: React.FC<CreateFolderModalProps> = ({
  open,
  onClose,
  onCreateFolder,
  folders,
  loading = false,
}) => (
  <FolderFormModal
    open={open}
    title="Create New Folder"
    submitButtonText="Create folder"
    folders={folders}
    loading={loading}
    onClose={onClose}
    onSubmit={onCreateFolder}
  />
);

export default CreateFolderModal;
